import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, ValueObject } from '@digibricks/core';
export var FileByteSize = /*#__PURE__*/function (_ValueObject) {
  _inherits(FileByteSize, _ValueObject);

  var _super = _createSuper(FileByteSize);

  function FileByteSize() {
    _classCallCheck(this, FileByteSize);

    return _super.apply(this, arguments);
  }

  _createClass(FileByteSize, [{
    key: "value",
    get: function get() {
      return this.props.value;
    }
  }], [{
    key: "create",
    value: function create(value) {
      if (!Number.isFinite(value) || value < 0) {
        return Result.fail('Invalid file size');
      }

      return Result.ok(new FileByteSize({
        value: value
      }));
    }
  }]);

  return FileByteSize;
}(ValueObject);